import { Location } from '@freelancer/location';
import * as i0 from "@angular/core";
import * as i1 from "../../location/location.service";
import * as i2 from "../ui.config";
var Assets = /** @class */ (function () {
    function Assets(location, uiConfig) {
        this.location = location;
        this.uiConfig = uiConfig;
    }
    Assets.prototype.getUrl = function (assetName) {
        // if the assets base url is relative, prepend with the current origin for
        // SSR to work
        return this.uiConfig.assetsBaseUrl.startsWith('/')
            ? "" + this.location.origin + this.uiConfig.assetsBaseUrl + "/" + assetName
            : this.uiConfig.assetsBaseUrl + "/" + assetName;
    };
    // PRIVATE API only used for SSR
    Assets.prototype.isAssetUrl = function (url) {
        return this.uiConfig.assetsBaseUrl.startsWith('/')
            ? url.startsWith("" + this.location.origin + this.uiConfig.assetsBaseUrl + "/")
            : url.startsWith(this.uiConfig.assetsBaseUrl + "/");
    };
    // PRIVATE API only used for SSR
    Assets.prototype.getAssetPath = function (url) {
        return url.replace(/^.*?(?=\/assets\/)\/assets\//, '');
    };
    Assets.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Assets_Factory() { return new Assets(i0.ɵɵinject(i1.Location), i0.ɵɵinject(i2.UI_CONFIG)); }, token: Assets, providedIn: "root" });
    return Assets;
}());
export { Assets };
